/**
 * Общий envelope для `room.send('command', …)` — как в лобби и игровых комнатах.
 * @param {string} command
 * @param {Record<string, unknown>} [data]
 */
export function createCommandEnvelope(command, data = {}) {
  return {
    command,
    meta: {
      commandId: `cmd-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      clientVersion: `web-${process.env.REACT_APP_VERSION || 'dev'}`,
    },
    data: data ?? {},
  };
}
